import { useState } from "react";

export const arrayMove = (arr, from, to) => { const a = [...arr]; a.splice(to, 0, a.splice(from, 1)[0]); return a; };

// Arrastar com o mouse para reordenar: devolve as props de cada linha.
export function useDragSort(ids, onMove) {
  const [drag, setDrag] = useState(null);
  const [over, setOver] = useState(null);
  const reset = () => { setDrag(null); setOver(null); };
  return (id, enabled = true) => {
    if (!enabled) return {};
    const mark = drag && over === id && drag !== id ? (ids.indexOf(drag) > ids.indexOf(id) ? "border-t-2 border-t-primary" : "border-b-2 border-b-primary") : "";
    return {
      draggable: true,
      onDragStart: (e) => { e.dataTransfer.effectAllowed = "move"; e.dataTransfer.setData("text/plain", id); setDrag(id); },
      onDragOver: (e) => { if (!drag) return; e.preventDefault(); e.dataTransfer.dropEffect = "move"; if (over !== id) setOver(id); },
      onDrop: (e) => { e.preventDefault(); if (drag && drag !== id) onMove(drag, id); reset(); },
      onDragEnd: reset,
      className: `${drag === id ? "opacity-40" : ""} ${mark}`,
    };
  };
}
